import { createFileRoute } from '@tanstack/react-router'
import { JobRoleDeletePage } from '@/features/job-roles/delete'

export const Route = createFileRoute('/job-roles_/$jobRoleId/delete')({
  component: RouteComponent,
})

function RouteComponent() {
  const { jobRoleId } = Route.useParams()
  return <JobRoleDeletePage jobRoleId={jobRoleId} />
}
